import { render } from "./DialogSelectMultiValidFramesCount.vue?vue&type=template&id=bf2a8808&scoped=true"
import script from "./DialogSelectMultiValidFramesCount.vue?vue&type=script&lang=js"
export * from "./DialogSelectMultiValidFramesCount.vue?vue&type=script&lang=js"

import "./DialogSelectMultiValidFramesCount.vue?vue&type=style&index=0&id=bf2a8808&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-bf2a8808"

export default script